export function advanceReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_SUPPLIER_ADVANCE":            
        case "UPDATE_ADVANCE":
            let list = Object.assign({}, state);
            list[payload.advance_id] = payload
        
            return list
            
        case "GET_ADVANCES":
            return payload
        case "DELETE_SUPPLIER_ADVANCE":
            let list2 = Object.assign({}, state);
            
            delete list2[payload]
            return list2
        case "UPDATE_ADVANCE_REST":
            let list3 = Object.assign({}, state);
            let rest = list3[payload.advance_src].advance_total_available - payload.advance_amount
            list3[payload.advance_src].advance_total_available = rest
            if (rest > 0) {
                list3[payload.advance_src].advance_available = true
            } else {
                list3[payload.advance_src].advance_available = false
            }
            return list3
                
        default:
            return state;
    }
    
}